import template from './urban-total-area-room.jade';
import validation from './../../../services/validation';

export default angular
    .module('cian.addForm.urbanTotalAreaRoom', [])
    .directive('cianAfAboutObjectUrbanTotalAreaRoom', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['deviceService', function (deviceService) {
            this.isMobile = deviceService.isMobile;
            this.areaMax = 10000000;
            this.getKitchenAndLivingArea = () => {
                return (Number(this.ad.livingArea) || 0) + (Number(this.ad.kitchenArea) || 0) + (Number(this.ad.roomArea) || 0); // значение может быть не задано, поэтому через 'или'
            };
            this.validation = validation(this.form, 'urbanTotalAreaRoom', {
                parse: 'Введите число',
                required: 'Укажите общую площадь',
                min: 'Общая площадь объекта не должна быть меньше суммы площадей кухни и комнаты',
                max: 'Допустимо не более 7 символов',
            });
        }],
        controllerAs: 'urbanTotalAreaRoom',
        template,
    }))
    .name;
